import axiosClient from "../../http-common";

class Mobile2BEmbedApiService {
  getEmbedSessionAsync = async (tenantId, containerId, signal) => {
    return axiosClient.get(
      `api/v1/tenants/${tenantId}/containers/${containerId}/mobile2b/embed-session`,
      { signal }
    );
  };
}

export default new Mobile2BEmbedApiService();
